export enum SocketEvent {
	NewNotification = 'new-notification',
	ListNotifications = 'me',
	MarkAsSeen = 'read',
	Subscribe = 'subscribe',
	Unsubscribe = 'unsubscribe',
	NotificationsTypes = 'list-notification-types',
	Connect = 'connect',
}
